var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderindexFolderLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.282,
    height: 24,
    viewBox: "0 0 31.282 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11794",
    "data-name": "Caminho 11794",
    d: "M745.312,233.4H732.7l-2.51-2.983a.43.43,0,0,0-.343-.154H719.663a2.828,2.828,0,0,0-2.808,2.829v18.346a2.829,2.829,0,0,0,2.825,2.825h25.632a2.829,2.829,0,0,0,2.825-2.825V236.222A2.829,2.829,0,0,0,745.312,233.4Z",
    transform: "translate(-716.855 -230.26)",
    fill: "#415364"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderindexFolderLarge);
export default __webpack_public_path__ + "static/media/folderindex-folder-large.c21280839fd7a9e4b15d7a25c4dbbce1.svg";
export { ForwardRef as ReactComponent };